import { render, staticRenderFns } from "./CustomerNeeds.vue?vue&type=template&id=364b4e2a&scoped=true&"
import script from "./CustomerNeeds.vue?vue&type=script&lang=js&"
export * from "./CustomerNeeds.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNeeds.vue?vue&type=style&index=0&id=364b4e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b4e2a",
  null
  
)

export default component.exports